<template>

    <div>
        <page-title :title="$t('orders.listTitle')"></page-title>

        <div class="flex flex-col sm:flex-row md:mt-0 mb-4 sm:space-x-8 items-end">
            <div class="flex flex-row flex-1 w-full">
                <filter-overlay>
                    <MultiSelect v-model="form.payment"
                                 :options="paymentStates"
                                 class="w-full col-span-3 mt-3"
                                 optionValue="value"
                                 appendTo="body"
                                 :showToggleAll="false"
                                 optionLabel="name"
                                 :placeholder="$t('orders.paymentState')">
                        <template #value="slotProps">
                            {{ $t('orders.paymentState') }}
                        </template>
                    </MultiSelect>

                    <MultiSelect v-model="form.fulfillment"
                                 :options="fulfillmentStates"
                                 class="w-full mt-3"
                                 optionValue="value"
                                 appendTo="body"
                                 :showToggleAll="false"
                                 optionLabel="name"
                                 :placeholder="$t('orders.fulfillmentState')">
                        <template #value="slotProps">
                            {{ $t('orders.fulfillmentState') }}
                        </template>
                    </MultiSelect>

                    <MultiSelect v-model="form.channel"
                                 :options="channels"
                                 class="w-full mt-3"
                                 optionValue="value"
                                 appendTo="body"
                                 :showToggleAll="false"
                                 optionLabel="name"
                                 :placeholder="$t('orders.channel')">
                        <template #value="slotProps">
                            {{ $t('orders.channel') }}
                        </template>
                    </MultiSelect>

                    <range-selector
                        class="w-full mt-3"
                        v-model="form.range"></range-selector>
                </filter-overlay>

                <search-bar class="flex-1"
                            @reset="reset"
                            :placeholder="$t('articles.search')" v-model="form.search"></search-bar>

                <sort v-model="form.sort" :options="sortOptions"></sort>

            </div>
        </div>
        <pagination class="my-6" :links="orders.links" prefix="t"></pagination>

        <div class="align-middle min-w-full overflow-x-auto shadow overflow-hidden sm:rounded-lg">
            <table class="min-w-full divide-y divide-gray-200">
                <thead class="bg-gray-50">
                <tr>
                    <th scope="col"
                        class="px-3 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                        <InformationCircleIcon class="h-5 w-5 text-gray-500"></InformationCircleIcon>
                    </th>
                    <th scope="col"
                        class="px-3 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                        {{ $t('orders.orderDate') }}
                    </th>
                    <th scope="col"
                        class="px-3 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                        {{ $t('orders.orderReceived') }}
                    </th>
                    <th scope="col"
                        class="px-3 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                        {{ $t('orders.number') }}
                    </th>

                    <th scope="col"
                        class="px-3 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                        {{ $t('orders.channel') }}
                    </th>

                    <th scope="col"
                        class="px-3 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                        {{ $t('orders.channelNo') }}
                    </th>

                    <th scope="col"
                        class="px-3 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                        {{ $t('orders.total') }}
                    </th>

                    <th scope="col"
                        class="px-3 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                        {{ $t('orders.customer') }}
                    </th>

                    <th scope="col"
                        class="px-3 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                        {{ $t('orders.paymentState') }}
                    </th>

                    <th scope="col"
                        class="px-3 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                        {{ $t('orders.fulfillmentState') }}
                    </th>

                </tr>
                </thead>
                <tbody class="bg-white divide-y divide-gray-200">
                <tr v-for="order in orders.data" :key="order.id">
                    <td class="px-3 py-4 whitespace-nowrap text-sm text-gray-500 flex">
                        <TruckIcon v-if="order.fulfilling" class="h-5 w-5 text-gray-400"></TruckIcon>
                        <ExclamationTriangleIcon v-if="order.critical"
                                                 class="h-5 w-5 text-red-400"></ExclamationTriangleIcon>
                    </td>
                    <td class="px-3 py-4 whitespace-nowrap text-sm text-gray-500">
                        {{ order.created_at }}
                    </td>
                    <td class="px-3 py-4 whitespace-nowrap text-sm text-gray-500">
                        {{ order.order_date }}
                    </td>
                    <td class="px-3 py-4 whitespace-nowrap text-sm text-gray-500">
                        <TextLink :href="route('sales.orders.view', order.id)">
                            {{ order.number }}
                        </TextLink>
                    </td>
                    <td class="px-3 py-4 whitespace-nowrap text-sm text-gray-500">
                        <dot :color="order.salesOrg.color"></dot>
                        {{ order.salesOrg.name }}
                    </td>
                    <td class="px-3 py-4 whitespace-nowrap text-sm text-gray-500">
                        {{ order.channel_no }}
                    </td>
                    <td class="px-3 py-4 whitespace-nowrap text-sm text-gray-500">
                        {{ order.grossTotal }}
                    </td>
                    <td class="px-3 py-4 whitespace-nowrap text-sm text-gray-500">
                        {{ order.customer }}
                    </td>
                    <td class="px-3 py-4 whitespace-nowrap text-sm text-gray-500">
                        <status :status="order.payment"></status>
                    </td>
                    <td class="px-3 py-4 whitespace-nowrap text-sm text-gray-500">
                        <status :status="order.fulfillment"></status>
                    </td>
                </tr>
                </tbody>
            </table>


        </div>

        <pagination class="mt-6" :links="orders.links" prefix="b"></pagination>

    </div>
</template>

<script>
import AppLayout from "@/Layouts/AppLayout";
import PageTitle from "@/Shared/Components/PageTitle";
import {
    ExclamationTriangleIcon,
    InformationCircleIcon,
    MagnifyingGlassIcon,
    TruckIcon
} from "@heroicons/vue/24/outline";
import SearchBar from "@/Shared/Components/SearchBar";
import Pagination from "@/Shared/Components/Pagination";
import {mapValues, pickBy, throttle} from "lodash";
import SwitchInput from "@/Shared/Components/SwitchInput";
import {ref} from "vue";
import Checkbox from "@/Jetstream/Checkbox";
import JetLabel from "@/Jetstream/Label";
import Sort from "@/Shared/Components/Sort";
import {i18n} from "@/app";
import FilterMenu from "@/Shared/Components/FilterMenu";
import TextLink from "@/Shared/Components/TextLink";
import Dot from "@/Shared/Components/Dot";
import Status from "@/Shared/Components/Status";
import SelectDropdown from "@/Shared/Components/SelectDropdown";
import FilterOverlay from "@/Shared/Components/FilterOverlay";
import RangeSelector from "@/Shared/Components/RangeSelector";
import moment from "moment";

const {t} = i18n.global;

const sortOptions = [
    {id: 'createdAt', name: t('orders.orderReceived')},
    {id: 'orderDate', name: t('orders.orderDate')},
    {id: 'channelNo', name: t('orders.channelNo')},
    {id: 'number', name: t('orders.number')},
    {id: 'grossTotal', name: t('orders.total')},
]

export default {
    components: {
        RangeSelector,
        FilterOverlay,
        SelectDropdown,
        Status,
        Dot,
        TextLink,
        FilterMenu,
        Checkbox,
        Pagination,
        SearchBar,
        PageTitle,
        MagnifyingGlassIcon,
        SwitchInput,
        Sort,
        TruckIcon,
        ExclamationTriangleIcon,
        InformationCircleIcon,
        JetLabel
    },
    layout: AppLayout,
    props: ['orders', 'filter', 'sort', 'channels', 'fulfillmentStates', 'paymentStates'],
    setup(props) {
        const resetting = ref(false);
        const channels = ref(props.channels);
        const paymentStates = ref(props.paymentStates);
        const fulfillmentStates = ref(props.fulfillmentStates);
        const form = ref({
            reset: null,
            search: props.filter.search,
            range: !props.filter.from || !props.filter.to ? null : [
                moment(props.filter.from).toDate(),
                moment(props.filter.to).toDate()
            ],
            channel: props.filter.channel ? props.filter.channel.split('|').map(val => +val) : null,
            payment: props.filter.payment ? props.filter.payment.split('|') : null,
            fulfillment: props.filter.fulfillment ? props.filter.fulfillment.split('|') : null,
            sort: props.sort
        })

        return {
            resetting,
            form,
            sortOptions,
            paymentStates,
            fulfillmentStates,
            channels
        }
    },
    watch: {
        form: {
            deep: true,
            handler: throttle(function () {
                let query = {
                    "filter[search]": this.form.search,
                    "filter[payment]": this.form.payment ? this.form.payment.join('|') : null,
                    "filter[channel]": this.form.channel ? this.form.channel.join('|') : null,
                    "filter[from]": this.form.range ? this.form.range[0] : null,
                    "filter[to]": this.form.range ? this.form.range[1] : null,
                    "filter[fulfillment]": this.form.fulfillment ? this.form.fulfillment.join('|') : null,
                    "sort": this.form.sort,
                    "reset": this.resetting ?? null,
                };

                this.resetting = false;

                this.$inertia.get(this.route("sales.orders.index"), pickBy(query), {
                    only: ['orders', 'filter', 'sort'],
                    preserveState: true,

                });
            }, 700)
        }
    },
    methods: {
        reset() {
            this.resetting = true;
            this.form = mapValues(this.form, (val, prop) => {
                return prop === 'sort' ? '-createdAt' : null;
            });
        }
    }

}
</script>

<style scoped>

</style>
